import { render, staticRenderFns } from "./AdminProdStock.vue?vue&type=template&id=ed79f146&scoped=true&"
import script from "./AdminProdStock.vue?vue&type=script&lang=js&"
export * from "./AdminProdStock.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdStock.vue?vue&type=style&index=0&id=ed79f146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed79f146",
  null
  
)

export default component.exports